import { useEffect, useRef, useState } from 'react';
import type { AINotification } from '../types/contracts';
import { timeAgo } from '../lib/format';

export function NotificationCenter({ notifications }: { notifications: AINotification[] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const unread = notifications.filter((n) => !n.read).length;

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="relative w-9 h-9 rounded-xl bg-white border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50"
        aria-label="الإشعارات"
      >
        <i className="ri-notification-3-line text-base" />
        {unread > 0 && (
          <span className="absolute -top-1.5 -end-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-black flex items-center justify-center">
            {unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute end-0 top-11 w-80 rounded-2xl bg-white border border-gray-100 shadow-xl z-30 overflow-hidden">
          <div className="px-4 py-2.5 border-b border-gray-50 flex items-center justify-between">
            <span className="text-xs font-black text-gray-800">الإشعارات</span>
            <span className="text-[10px] text-gray-400">{unread} غير مقروء</span>
          </div>
          <ul className="max-h-80 overflow-y-auto divide-y divide-gray-50">
            {notifications.map((n) => (
              <li key={n.id} className={`px-4 py-3 flex items-start gap-2.5 ${n.read ? 'opacity-60' : ''}`}>
                <i className={`${n.icon} text-base text-teal-700 mt-0.5`} />
                <div className="min-w-0">
                  <p className="text-xs font-semibold text-gray-800 leading-snug">{n.title}</p>
                  <p className="text-[10px] text-gray-400 mt-0.5">{timeAgo(n.at)}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
